<div [id]="idModal" class="modal fade regiao-representante-popula-modal" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Adicionar representantes na região
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="table-responsive">
                        <table class="table table-striped table-hover datatables" [id]="idDataTable">
                            <thead>
                                <tr>
                                    <th class="col-select text-center">
                                        <div class="custom-control custom-checkbox" *ngIf="popula && popula.length > 0">
                                            <input type="checkbox" class="custom-control-input" [(ngModel)]="allRepresentantesSelected" name="allRepresentantesSelected" id="allRepresentantesSelected" (ngModelChange)="onChangeAllRepresentantesSelected($event)">
                                            <label class="custom-control-label" for="allRepresentantesSelected">Todos</label>
                                        </div>     
                                    </th>
                                    <th class="col-nome">Nome</th>
                                    <th class="col-fantasia">Fantasia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let entityPopula of popula; let i = index"
                                    [class.exist]="entityPopula.exist">
                                    <td class="col-select text-center">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" [disabled]="entityPopula.exist" [(ngModel)]="entityPopula.selected" 
                                                name="entityPopulaSelected_{{i}}" id="entityPopulaSelected_{{i}}"  (ngModelChange)="onChangeRepresentanteSelected()">
                                                <label class="custom-control-label" for="entityPopulaSelected_{{i}}"></label>
                                        </div>                                          
                                    </td>
                                    <td class="col-nome" (click)="selectRepresentante(entityPopula)">
                                        {{entityPopula.regiaoRepresentante?.representante.pessoa?.nome}}
                                    </td>
                                    <td class="col-fantasia" (click)="selectRepresentante(entityPopula)">
                                        {{entityPopula.regiaoRepresentante?.representante.pessoa?.nomeFantasia}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="adicionar()" id="btnAdicionar">
                    Adicionar
                </button>
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>